export enum Color {
  BrightOrange = '#f80000',
  Green = '#54d704',
  LightBlack = '#555252',
  LightGrey = '#f3f3f3',
  Orange = '#f4735e',
  PaleGreen = '#8ccc65',
  Red = '#e0381d',
  WarmGrey = '#766c6c',
  White = '#fff',
}
export enum RgbColor {
  Black = '0, 0, 0',
  LightBlack = '85, 82, 82',
  Red = '224, 56, 29',
}